import contentRequest from '~/src/api/requests/contentRequest';

export const routerRequest = async(routerClassId, materialsEnsId, posess_price, leasing_price, leasingDuration, initialData) => {
    const router = await contentRequest.getWithCache(`v1/city/router-classes?materialsEnsId=${materialsEnsId}`)
        .then(request => request.data[0])
        .catch(e => (console.log(e)));

    if (!router) {
 return;
}

    // если в get параметрах есть posess_price, значит полная оплата
    if (posess_price) {
        initialData.once.list.push({
            name: router.materialsEnsName,
            price: router.posessPrice,
            formData: [
                {
                    key: 'router',
                    value: materialsEnsId
                },
                {
                    key: 'cost_type',
                    value: 1
                },
                {
                    key: 'product_id',
                    value: 0
                }
            ]
        });
        initialData.once.total = Number(initialData.once.total) + Number(router.posessPrice);
    }

    // если в get параметрах есть leasing_price, значит оплата в рассрочку
    if (leasing_price) {
        initialData.monthly.list.push({
            name: router.materialsEnsName + ` (Рассрочка на ${leasingDuration} мес.)`,
            price: leasing_price,
            formData: [
                {
                    key: 'router',
                    value: materialsEnsId
                },
                {
                    key: 'cost_type',
                    value: 5
                },
                {
                    key: 'leasing_price',
                    value: leasing_price
                },
                {
                    key: 'leasing_duration',
                    value: leasingDuration
                },
                {
                    key: 'product_id',
                    value: 0
                }
            ]
        });
        initialData.monthly.total = Number(initialData.monthly.total) + Number(leasing_price);
    }
};

export const addRouterInCheckPosess = (router, currentCheck, deleteEquipment) => {

    const augmentedCheck = { ...currentCheck };

    augmentedCheck.once.list.push({
        materialsEnsId: router.materialsEnsId,
        name: router.materialsEnsName,
        price: router.posessPrice,
        formData: [
            {
                key: 'router',
                value: router.materialsEnsId
            },
            {
                key: 'cost_type',
                value: 1
            }
        ],
        deleteItem: () => deleteEquipment(router.materialsEnsId)
    });
    augmentedCheck.once.total = Number(augmentedCheck.once.total) + Number(router.posessPrice);

    return augmentedCheck;
};

export const addRouterInCheckLeasing = (router, leasingOption, currentCheck, deleteEquipment) => {

    const augmentedCheck = { ...currentCheck };
    const leasingDuration = Number(leasingOption.duration);
    const price = Number(leasingOption.price);

    augmentedCheck.monthly.list.push({
        materialsEnsId: router.materialsEnsId,
        name: router.materialsEnsName + ` (Рассрочка на ${leasingDuration} мес.)`,
        price,
        formData: [
            {
                key: 'router',
                value: router.materialsEnsId
            },
            {
                key: 'cost_type',
                value: 5
            },
            {
                key: 'leasing_price',
                value: price
            },
            {
                key: 'leasing_duration',
                value: leasingDuration
            }
        ],
        deleteItem: () => deleteEquipment(router.materialsEnsId)
    });
    augmentedCheck.monthly.total = Number(augmentedCheck.monthly.total) + price;

    return augmentedCheck;
};
